import { Component, OnInit } from '@angular/core';
import { Globals } from '../../global';

@Component({
  selector: 'app-first-home-purchase',
  templateUrl: './first-home-purchase.component.html',
  styleUrls: ['./first-home-purchase.component.scss']
})
export class FirstHomePurchaseComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal = '';

  ngOnInit() {
    const modal = this.globals.getModalValue();
    if (undefined !== modal) {
      this.section_modal = modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }
}
